export default {
  name: 'FixFluidColGrid',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isMaxHeight: {
      type: Boolean,
      default: false
    }
  }
}